import {
  Cog8ToothIcon as Cog,
  EnvelopeIcon,
  UsersIcon,
} from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

type MenuItemId = 'dashboard' | 'settings' | 'contact' | 'school-subscription';

export interface MenuItem {
  id: MenuItemId;
  route: string;
  icon?: any;
  title: string;
  disabled: boolean;
  hidden?: boolean;
  isActiveFct?: (p: string) => boolean;
  subItems?: MenuItem[];
}

export function useGetDirectorRoutes(): MenuItem[] {
  const { t } = useTranslation(['common']);

  const licensesMenuItem: MenuItem = {
    id: 'school-subscription',
    route: '/direction/school-subscription',
    icon: UsersIcon,
    title: t('common:sidebar.licenses'),
    disabled: false,
  };

  const contactUsMenuItem: MenuItem = {
    id: 'contact',
    icon: EnvelopeIcon,
    route: '/direction/contact',
    title: t('common:sidebar.contact'),
    disabled: false,
  };

  const settingsMenuItem: MenuItem = {
    id: 'settings',
    icon: Cog,
    route: '/direction/settings/account',
    title: t('common:sidebar.settings'),
    disabled: false,
  };

  return [licensesMenuItem, contactUsMenuItem, settingsMenuItem];
}
